// Language-specific field validation (mirrors mobile app rules).
const NOT_AR = /(?!\p{Script=Arabic})\p{L}/u;
const NOT_EN = /(?![A-Za-z])\p{L}/u;

export const LANG_MSG = { ar: "يرجى الكتابة باللغة العربية فقط", en: "Please write in English only" };
export const wrongLang = (text, lang) => !!text && (lang === "ar" ? NOT_AR : NOT_EN).test(String(text));

export function LangWarn({ text, lang, testid }) {
  if (!wrongLang(text, lang)) return null;
  return <p className="text-xs font-bold text-[#B91C1C] mt-1" dir={lang === "ar" ? "rtl" : "ltr"} data-testid={testid || "lang-warning"}>{LANG_MSG[lang]}</p>;
}
